import { SonarLessonActorType } from "./sonarLessonMachine/types";

export enum LessonIdType {
    sonarLesson = "sonarLesson",
    basicGunLesson = "basicGunLesson",
}

export type LessonActorType = SonarLessonActorType;
